/**
 * cherryDev brand tokens — cereza + hoja (independiente del tema TNO).
 * Wordmark: "cherry" fino + "Dev" grueso, pegado; cerezas al final en el logo.
 */
export const CHERRY_DEV = {
  name: 'cherryDev',
  cherry: '#C41E3A',
  cherryDark: '#8B1528',
  cherryLight: '#E85A6B',
  leaf: '#1B7A4E',
  leafDark: '#0F5A38',
  leafLight: '#3DA06A',
  blush: '#FFF5F4',
  blushDeep: '#FFE8E6',
  ink: '#1C1214',
  inkMuted: '#5C4A4E',
  cream: '#FFFBFA',
  white: '#FFFFFF',
};

export const CHERRY_DEV_LOGO = '/images/cherry-software/logo.svg';
